import script from "./AiOrderDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AiOrderDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AiOrderDrawer.vue?vue&type=style&index=0&id=7bc83e8e&lang=css"
import "./AiOrderDrawer.vue?vue&type=style&index=1&id=7bc83e8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc83e8e"]])

export default __exports__